import { Injectable } from '@angular/core';
import { PaginationDto, ResponsePackage } from '../models/util.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { AssetForInstallationAssign, InstallationTableData } from '../models/installation.model';
import { KeyValueItem } from '../models/keyValueItem.model';
import { MeterInventoryType } from '../enums/meter-inventory-type.enum';
import { DtMeterInstallationInvoiceDetailsDto, DtMeterInstallationInvoiceDto, DtMeterInstallationInvoiceInstalledDt, DtMeterInstallationInvoiceInstalledDtPageInfo, DtMeterInstallationInvoicePageInfo, DtMeterInstallationInvoicePeriod, DtMeterInstallationInvoiceStatus } from '../models/dt-meter-installation-invoice.model';

@Injectable({
  providedIn: 'root'
})
export class InstallationService {
  private pathApi = this.config.setting['pathApi'] + "installation/";
  private headers = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http: HttpClient, private config: AppConfig) { }
  getAll(obj: any) {
    return this.http.post<ResponsePackage<PaginationDto<InstallationTableData>>>(`${this.pathApi}getAll`, obj, {headers: this.headers, observe: 'response'});
  }
  getAllDtMeterInstallationInvoices(obj: DtMeterInstallationInvoicePageInfo) {
    return this.http.post<ResponsePackage<PaginationDto<DtMeterInstallationInvoiceDto>>>(`${this.pathApi}getAllDtMeterInstallationInvoices`, obj, {headers: this.headers, observe: 'response'});
  }
  getDtMeterInstallationInvoiceById(id: number) {
    return this.http.get<ResponsePackage<DtMeterInstallationInvoiceDetailsDto>>(`${this.pathApi}getDtMeterInstallationInvoice/${id}`, {headers: this.headers, observe: 'response'});
  }
  getDtMeterInstallationInvoiceInstalledDts(obj: DtMeterInstallationInvoiceInstalledDtPageInfo) {
    return this.http.post<ResponsePackage<PaginationDto<DtMeterInstallationInvoiceInstalledDt>>>(`${this.pathApi}getDtMeterInstallationInvoiceInstalledDts`, obj, {headers: this.headers, observe: 'response'});
  }
  getDtMeterInstallationInvoicePeriodsForSelect(status: DtMeterInstallationInvoiceStatus) {
    return this.http.get<ResponsePackage<DtMeterInstallationInvoicePeriod[]>>(`${this.pathApi}getDtMeterInstallationInvoicePeriodsForSelect?status=${status}`, {headers: this.headers, observe: 'response'});
  }
  getDtMeterInstallationInvoiceStats() {
    return this.http.get<ResponsePackage<KeyValueItem[]>>(`${this.pathApi}getDtMeterInstallationInvoiceStats`, {headers: this.headers, observe: 'response'});
  }
  acknowledgeInvoiceRepayment(id: number) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}acknowledgeInvoiceRepayment`, id, {headers: this.headers, observe: 'response'});
  }
  getAllDtInstallations(obj: any) {
    return this.http.post<ResponsePackage<PaginationDto<InstallationTableData>>>(`${this.pathApi}getAllDtInstallations`, obj, {headers: this.headers, observe: 'response'});
  }
  getInstallationStats(meterInventoryType: MeterInventoryType = MeterInventoryType.Customer) {
    return this.http.get<ResponsePackage<KeyValueItem[]>>(`${this.pathApi}getInstallationStats?meterInventoryType=${meterInventoryType}`,{headers: this.headers, observe: 'response'});
  }
  assignInstalations(obj: any) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}assignInstallations`, obj, {headers: this.headers, observe: 'response'});
  }
  assignAssetInstallations(obj: any) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}assignAssetInstallations`, obj, {headers: this.headers, observe: 'response'});
  }
  getAssetsForInstallationAssignOptions(search: string) {
    return this.http.get<ResponsePackage<AssetForInstallationAssign[]>>(`${this.pathApi}getAssetsForInstallationAssignOptions?search=${encodeURIComponent(search)}`, {headers: this.headers, observe: 'response'});
  }
  assignVendorInstallations(obj: any) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}assignVendorInstallations`, obj, {headers: this.headers, observe: 'response'});
  }
  getAuthorizedDtsForVendorAssignOptions(search: string) {
    return this.http.get<ResponsePackage<AssetForInstallationAssign[]>>(`${this.pathApi}getAuthorizedDtsForVendorAssignOptions?search=${encodeURIComponent(search)}`, {headers: this.headers, observe: 'response'});
  }
  download(obj:any){
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}downloadFile`, obj, {headers: this.headers, observe: 'response'});
  }
  getDetailsById(id:number){
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}details/${id}`,{headers: this.headers, observe: 'response'});
  }
  getDtDetailsById(id:number){
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}dtDetails/${id}`,{headers: this.headers, observe: 'response'});
  }
  getDtInstallationPeriods(){
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}dtInstallationPeriods`,{headers: this.headers, observe: 'response'});
  }
  requestDtMeterApprovalOtp(obj:any){
    return this.http.post<ResponsePackage<any>>(`${this.pathApi}requestDtMeterApprovalOtp`, obj, {headers: this.headers, observe: 'response'});
  }
  requestDtMeterInvoiceApprovalOtp(obj:any){
    return this.http.post<ResponsePackage<any>>(`${this.pathApi}requestDtMeterInvoiceApprovalOtp`, obj, {headers: this.headers, observe: 'response'});
  }
  approveDtMeterInstallationInvoice(obj:any){
    return this.http.post<ResponsePackage<any>>(`${this.pathApi}approveDtMeterInstallationInvoice`, obj, {headers: this.headers, observe: 'response'});
  }
  approveDtMeterInstallationMeter(obj:any){
    return this.http.post<ResponsePackage<any>>(`${this.pathApi}approveDtMeterInstallationMeter`, obj, {headers: this.headers, observe: 'response'});
  }
  approveInstallation(obj:any):Observable<any>{
    return this.http.post(`${this.pathApi}approveInstallation`, obj);
  }
  rejectInstallation(obj:any):Observable<any>{
    return this.http.post(`${this.pathApi}rejectInstallation`, obj);
  }
  recallInstallation(id:number):Observable<any>{
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}recallInstallation`, id, {headers: this.headers, observe: 'response'});
  }
  acceptDtInstallation(id:number):Observable<any>{
    return this.http.post(`${this.pathApi}acceptDtInstallation`, id);
  }
  declineDtInstallation(obj:any):Observable<any>{
    return this.http.post(`${this.pathApi}declineDtInstallation`, obj);
  }
  generateBulkAssignmentTemplate(): Observable<any> {
    return this.http.get(`${this.pathApi}getBulkAssignInstallationTemplate`);
  }
  generateBulkDtVendorAssignmentTemplate(): Observable<any> {
    return this.http.get(`${this.pathApi}getBulkDtVendorAssignmentTemplate`);
  }
  generateBulkDtInstallerAssignmentTemplate(): Observable<any> {
    return this.http.get(`${this.pathApi}getBulkDtInstallerAssignmentTemplate`);
  }
  generateBulkDtVendorReassignmentTemplate(): Observable<any> {
    return this.http.get(`${this.pathApi}getBulkDtVendorReassignmentTemplate`);
  }
  uploadBulkDtVendorAssignment(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadBulkDtVendorAssignment`, obj);
  }
  uploadBulkDtInstallerAssignment(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadBulkDtInstallerAssignment`, obj);
  }
  uploadBulkDtVendorReassignment(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadBulkDtVendorReassignment`, obj);
  }
  uploadBulkAssignment(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadBulkAssignInstallation`, obj);
  }
  resendInstallationForm(obj: any) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}resendInstallationForm`, obj, {headers: this.headers, observe: 'response'});
  }
}
